import type { GameConfig } from "../config";

// Difficulty interpolates the ini tuning from its "start" to "min/max" values
// over ramp_seconds, and gates the two stages:
//   Stage 1 (< stage1_seconds): only window zombies, intensity rising. On crawl
//     expiry they just retreat/vanish (no falling).
//   Stage 2 (>= stage1_seconds): on crawl expiry zombies fall out and walk.
export interface Difficulty {
  spawnInterval: number;
  maxZombies: number;
  crawlTime: number; // window dwell time before retreat (stage 1) / fall (stage 2)
  walkerTraverse: number;
  walkersEnabled: boolean;
}

function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

function clamp01(t: number): number {
  return t < 0 ? 0 : t > 1 ? 1 : t;
}

export function makeDifficulty(config: GameConfig, getElapsed: () => number): () => Difficulty {
  const d = config.difficulty;
  const sp = config.spawning;
  return () => {
    const t = getElapsed();
    const k = clamp01(t / Math.max(0.001, d.ramp_seconds)); // 0 -> 1 ramp, then holds at hardest
    const walkersEnabled = t >= d.stage1_seconds;
    return {
      spawnInterval: lerp(sp.spawn_interval_start, sp.spawn_interval_min, k),
      maxZombies: Math.round(lerp(sp.max_zombies_start, sp.max_zombies_max, k)),
      crawlTime: lerp(d.crawl_time_start, d.crawl_time_min, k),
      walkerTraverse: lerp(d.walker_traverse_start, d.walker_traverse_min, k),
      walkersEnabled,
    };
  };
}
